export interface HttpRequestOptions {
  readonly signal?: AbortSignal;
}

/** Abstraction minimale du transport HTTP, pour garder les passerelles testables. */
export interface HttpClient {
  postJson<TResponse>(
    path: string,
    body: unknown,
    options?: HttpRequestOptions,
  ): Promise<TResponse>;
}

export class HttpError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
  }
}
